// extracted by mini-css-extract-plugin
export default {"title":"TeaseFormTitle_title__3p8oF","text":"TeaseFormTitle_text__5bIfR"};